import React, { useEffect, useState } from "react";
import API from "../lib/api";
import { toast } from "sonner";
import AdminLayout from "./AdminLayout";
import { useAppT } from "../components/home/i18n";
import { Users, ShieldCheck } from "lucide-react";

export default function AdminHome() {
  const { a } = useAppT();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try { const { data } = await API.get("/admin/users"); setUsers(data.users); }
    catch (e) { toast.error(e.response?.data?.detail || a.adminHome.failedLoad); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const roleColor = { admin: "text-[#8B3A3A]", employer: "text-[#1F4A38]", candidate: "text-[#2E6B4B]" };

  return (
    <AdminLayout>
      <h1 className="font-serif text-3xl text-[#173A2C]">{a.adminHome.title}</h1>
      <div className="my-6 flex items-start gap-2 rounded-md border border-[#1F4A38]/25 bg-[#1F4A38]/6 p-4">
        <ShieldCheck className="mt-0.5 h-5 w-5 text-[#1F4A38]" />
        <p className="text-sm text-[#2C2A29]">{a.adminHome.seedNote}<b>{a.adminHome.seedNoteBold}</b>{a.adminHome.seedNotePost}</p>
      </div>
      <div className="rounded-md border border-[#E8E4DB] bg-white">
        <div className="flex items-center justify-between border-b border-[#E8E4DB] px-5 py-3">
          <div className="flex items-center gap-2 text-sm font-semibold text-[#173A2C]"><Users className="h-4 w-4 text-[#C4A46B]" /> {a.adminHome.allAccounts}</div>
          <span data-testid="admin-user-count" className="text-xs text-[#5C5855]">{loading ? "…" : `${users.length} ${a.adminHome.usersSuffix}`}</span>
        </div>
        <div className="overflow-x-auto thin-scroll">
          <table className="w-full min-w-[560px] text-left text-sm">
            <thead><tr className="border-b border-[#E8E4DB] text-[11px] uppercase tracking-wide text-[#5C5855]"><th className="px-5 py-2.5">{a.adminHome.colName}</th><th className="py-2.5">{a.adminHome.colEmail}</th><th className="py-2.5">{a.adminHome.colRole}</th><th className="py-2.5">{a.adminHome.colVerified}</th></tr></thead>
            <tbody data-testid="admin-users-table">
              {loading ? <tr><td colSpan="4" className="px-5 py-6 text-center text-[#5C5855]">{a.common.loading}</td></tr>
                : users.length === 0 ? <tr><td colSpan="4" className="px-5 py-6 text-center text-[#5C5855]">{a.adminHome.noUsers}</td></tr>
                : users.map((u) => (
                  <tr key={u.id} className="border-b border-[#E8E4DB] last:border-0">
                    <td className="px-5 py-2.5 text-[#2C2A29]">{u.name}</td>
                    <td className="py-2.5 text-[#5C5855]">{u.email}</td>
                    <td className={`py-2.5 font-medium ${roleColor[u.role] || ""}`}>{a.respMap[u.role] || u.role}</td>
                    <td className="py-2.5">{u.email_verified ? <span className="text-[#2E6B4B]">{a.common.yes}</span> : <span className="text-[#D28E3D]">{a.common.no}</span>}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
